import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import logo from '../../../images/logo-white.png';
import { Spacer } from '../../Spacer';
import { SocialButton } from '../../social-button/SocialButton';
import { StyledFooter } from './footer.style';
import { getLocalizedPath } from '../../../utils/lang';

export const Footer = () => {
  const { t } = useTranslation();
  const env = import.meta.env.VITE_ENVIRONMENT;
  const appVersion = import.meta.env.VITE_APP_VERSION;

  return (
    <StyledFooter>
      <div>
        <img id='footer-logo' src={logo} alt="illustroke logo white" />
        <p>{t('footer_tagline')}</p>
        <Spacer />
      </div>
      <div className='social'>
        <SocialButton social="x" />
        <SocialButton social="instagram" />
        <SocialButton social="tiktok" />
      </div>
      <div className="links">
        <a href='mailto:info@illustroke.com'>info@illustroke.com</a>
      </div>
      <div className="links-secondary">
        <Link to={getLocalizedPath("/affiliate")}>{t('footer_affiliate_marketing')}</Link>
        <Link to={getLocalizedPath("/pricing")}>{t('footer_pricing')}</Link>
        <Link to={getLocalizedPath("/api")}>{t('footer_api')}</Link>
        <Link to={getLocalizedPath("/privacy")}>{t('footer_privacy_policy')}</Link>
        <Link to={getLocalizedPath("/terms")}>{t('footer_terms_and_conditions')}</Link>
      </div>
      <div className='credits'>
        <p><Trans i18nKey="footer_made_by" values={{ company: 'Digitalbore OU' }} components={{ b: <b /> }} /></p>
        {env === "development" && <p>DEV Mode: {import.meta.env.VITE_FIREBASE_PROJECT_ID}</p>}
        <p>{t('footer_version', { version: appVersion, env })}</p>
      </div>
    </StyledFooter>
  )
};